import {
    apiArticleByParams,
    apiTagsByTagName,
} from "../../api/article.js";
export const actions = {
    async findTagsByTagName({ commit }, tag_name) {
        const rs = await apiTagsByTagName(tag_name);
        if (rs && rs.status == 200) {
            let data = rs.data
            return data
        }
    },

    async findArticleByParams({ commit }, params) {
        const rs = await apiArticleByParams(params);
        if (rs && rs.status == 200) {
            let data = rs.data
            return data
        }
    },
}